module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Discount Rate Comparison",
      "set-position": "relative",
      "create-button": true,
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-discount-rate-comparison"
  }, [_c('page-form'), _vm._v(" "), (!_vm.results.count) ? _c('div', [_c('hr'), _vm._v(" "), (_vm.results.count == 0) ? _c('p', {
    staticClass: "a-form-inputs--error"
  }, [_c('br'), _vm._v("\n                There are no results for your criteria\n                "), _c('br')]) : _c('div', [_c('h2', [_vm._v("\n                    Your results will appear here once you click compare.\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.results !== false && _vm.results.count > 0) ? _c('accordion', [_c('average-past-future-losses'), _vm._v(" "), _c('total-past-future-losses'), _vm._v(" "), (_vm.claimType) ? _c('all-heads-of-loss') : _vm._e(), _vm._v(" "), (_vm.claimType === 'fatal_accident_estate' || _vm.claimType === 'fatal_accident_dependency') ? _c('assessments-by-age') : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e766eda6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/DiscountRateComparison.vue
// module id = 1828
// module chunks = 0